import { FormControl, FormLabel, Grid, Stack, Switch, TextField } from '@mui/material';

import { Field, useFormikContext } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { translations } from 'locales/i18n';
import { validateField } from 'utils/FormErrorHelper';

import { moduleInSelectionValidationSchema } from '../validation';

export default function PeriodsAndParticipants() {
  const { t } = useTranslation();

  const { setFieldValue, values, errors, touched }: any = useFormikContext();
  const [customErrors, setCustomErrors] = useState({} as Record<string, string>);

  const handleChangeMinParticipants = event => {
    if (event.target.value === '') {
      setFieldValue('minParticipants', null);
      return;
    }
    event.target.value < 0
      ? setFieldValue('minParticipants', (event.target.value = Math.abs(event.target.value)))
      : setFieldValue('minParticipants', event.target.value);
  };

  const handleChangeMaxParticipants = async event => {
    if (event.target.value === '') {
      setFieldValue('maxParticipants', null);
      return;
    }
    event.target.value < 0
      ? setFieldValue('maxParticipants', (event.target.value = Math.abs(event.target.value)))
      : setFieldValue('maxParticipants', event.target.value);
    if (!!values.id && !values.isDefault) {
      const validation = await validateField(
        'maxParticipants',
        event.target.value,
        yup.object().shape(moduleInSelectionValidationSchema(t))
      );
      setCustomErrors({ ...customErrors, maxParticipants: validation });
    }
  };

  return (
    <Grid container spacing={4}>
      <Grid container item>
        <FormControl className="moduleModal__body__input" fullWidth>
          <FormLabel className="moduleModal__body__input__label">
            {t(translations.pages.modules.create.periodsAndParticipants.participants.title())}
          </FormLabel>
          <Grid container spacing={2}>
            <Grid container item xs={5}>
              <Field
                as={TextField}
                name="minParticipants"
                type="number"
                fullWidth
                onChange={handleChangeMinParticipants}
                label={t(
                  translations.pages.modules.create.periodsAndParticipants.participants.min()
                )}
                helperText={touched.minParticipants && errors.minParticipants}
              />
            </Grid>
            <Grid container item xs={5}>
              <Field
                as={TextField}
                name="maxParticipants"
                type="number"
                fullWidth
                onChange={handleChangeMaxParticipants}
                label={t(
                  translations.pages.modules.create.periodsAndParticipants.participants.max()
                )}
                helperText={
                  touched.maxParticipants && !!values.id && !values.isDefault
                    ? customErrors.maxParticipants
                    : errors.maxParticipants
                }
                error={
                  touched.maxParticipants && !!values.id && !values.isDefault
                    ? Boolean(customErrors.maxParticipants)
                    : Boolean(errors.maxParticipants)
                }
                required={!!values.id && !values.isDefault}
              />
            </Grid>
          </Grid>
        </FormControl>
        <FormControl className="moduleModal__body__input" fullWidth>
          <Grid container>
            <Stack direction="row" spacing={1} alignItems="center">
              <Switch
                checked={values.isMoveUpActive}
                value={values.isMoveUpActive}
                onChange={(_e, checked) => setFieldValue('isMoveUpActive', checked)}
              />
              <FormLabel sx={{ marginLeft: 1 }} color="primary">
                {t(translations.pages.modules.create.periodsAndParticipants.isMoveUpActive())}
              </FormLabel>
            </Stack>
          </Grid>
        </FormControl>
        {!!values?.id && !values?.isDefault ? (
          <FormControl className="moduleModal__body__input" fullWidth>
            <Grid container>
              <Stack direction="row" spacing={1} alignItems="center">
                <Switch
                  checked={values.isTakingPlace}
                  value={values.isTakingPlace}
                  onChange={(_e, checked) => setFieldValue('isTakingPlace', checked)}
                />
                <FormLabel>
                  {t(translations.pages.modules.create.periodsAndParticipants.takingPlace())}
                </FormLabel>
              </Stack>
            </Grid>
          </FormControl>
        ) : null}
      </Grid>
    </Grid>
  );
}
